import { ReactNode } from 'react';
import { TenantProvider as TenantContextProvider } from '@/hooks/use-tenant';

export function TenantProvider({ children }: { children: ReactNode }) {
  return <TenantContextProvider>{children}</TenantContextProvider>;
}